// ©2024 Austin App House. All rights reserved.
import '../../../sass/custom_styles/wo_details.css';
import '../../../sass/custom_styles/dashboard-modals.css';
import '../../../sass/custom_styles/dashboard-responsive.css';
import React, { useCallback, useEffect, useState } from 'react';
import Header from './NavHeader';
import Sidebar from './NavSidebar';
import Modal from '../../modal';
import { isMobileNav, MOBILE_NAV_MQ } from './dashboardNav';

const ControlPanel = ({ children }) => {
  const [isNavOpen, setNavOpen] = useState(false);

  const closeNav = useCallback(() => setNavOpen(false), []);

  useEffect(() => {
    const layout = document.getElementById('qweewq');
    if (!layout) return undefined;

    layout.classList.toggle('sidebar-open', isNavOpen);
    document.body.classList.toggle('dashboard-nav-open', isNavOpen);

    return () => {
      layout.classList.remove('sidebar-open');
      document.body.classList.remove('dashboard-nav-open');
    };
  }, [isNavOpen]);

  useEffect(() => {
    const mobileMq = window.matchMedia(MOBILE_NAV_MQ);

    const onResize = () => {
      if (window.innerWidth > 768) closeNav();
    };

    const onMqChange = () => {
      if (!mobileMq.matches) closeNav();
    };

    window.addEventListener('resize', onResize, { passive: true });
    mobileMq.addEventListener('change', onMqChange);

    return () => {
      window.removeEventListener('resize', onResize);
      mobileMq.removeEventListener('change', onMqChange);
    };
  }, [closeNav]);

  const onMainColumnClick = () => {
    if (isMobileNav() && isNavOpen) closeNav();
  };

  return (
    <>
      <div
        className="dashboard-nav-scrim"
        aria-hidden={!isNavOpen}
        role="presentation"
        tabIndex={-1}
        onClick={closeNav}
      />
      <Sidebar isNavOpen={isNavOpen} setNavOpen={setNavOpen} />
      <div className="dashboard-main-column" onClick={onMainColumnClick} role="presentation">
        <Header />
        {children}
      </div>
      <Modal />
    </>
  );
};

export default ControlPanel;
